import { render, staticRenderFns } from "./ChecklistAcessorio.vue?vue&type=template&id=466acb42&scoped=true&"
import script from "./ChecklistAcessorio.vue?vue&type=script&lang=js&"
export * from "./ChecklistAcessorio.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistAcessorio.vue?vue&type=style&index=0&id=466acb42&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466acb42",
  null
  
)

export default component.exports